import Backbone from 'backbone';

const NavView = Backbone.View.extend({
  render() {
    this.$el.css('visibility', 'visible');
  },
});

export default NavView;
